module.exports = __webpack_public_path__ + "img/button-light-02.2b77e8d5.png";